// common localized variables that are different in US, CA, UK, IE
export const localeName = "CANADA"; 
export const color = "colour";
export const colorCapitalized = "Colour";
export const phoneNumber = "1-800-300-1336";
export const quartzPath = "//cdn.4imprint.ca/qtz";
export const productImagePath = "https://cdn.4imprint.ca/prod";
export const regSM = "&reg;";
export const certainDeliveryParagraph = "It's on time or it's on us. If your event is missed because we didn't ship on time, your order is free.";
export const certainHappinessParagraph = "If you're not 100% satisfied with your order, we'll pay to pick it up and rerun it or refund your money—your choice.";